import { formatInTimeZone, toZonedTime, fromZonedTime } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';

const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export const money = (cents: number | null | undefined) => brl.format((cents ?? 0) / 100);

/** "R$ 1.234,56" | "1234,56" -> centavos */
export function parseMoney(v: string): number {
  const clean = v.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
  const n = Number(clean);
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
}

export const centsToInput = (cents: number | null | undefined) =>
  ((cents ?? 0) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (iso: string | Date, tz: string, pattern = 'dd/MM/yyyy') => formatInTimeZone(iso, tz, pattern, { locale: ptBR });
export const fmtDateTime = (iso: string | Date, tz: string) => formatInTimeZone(iso, tz, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
export const fmtTime = (iso: string | Date, tz: string) => formatInTimeZone(iso, tz, 'HH:mm', { locale: ptBR });
export { toZonedTime, fromZonedTime };

export const digits = (v: string) => v.replace(/\D/g, '');

export function maskCpf(v: string) {
  return digits(v)
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export function maskCnpj(v: string) {
  return digits(v)
    .slice(0, 14)
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
}

export function maskCep(v: string) {
  return digits(v).slice(0, 8).replace(/(\d{5})(\d)/, '$1-$2');
}

export function maskPhone(v: string) {
  const d = digits(v).slice(0, 11);
  if (d.length <= 10) return d.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
  return d.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
}

export function maskMoney(v: string) {
  const d = digits(v);
  return centsToInput(Number(d || '0'));
}
